<template>
 <div>
  <b-row align="center">
     <b-col>
      <b>{{description}}</b>
     </b-col>
      <b-col md="1">
        <data-navagations
          :can_update="isAdminPath"
          @update="doUpdate"
          @cancel="doCancel"
          @help="doHelp"
        ></data-navagations>
      </b-col>
   </b-row>
   <div v-if="ams_data.attributes">
    <b-img thumbnail fluid
      :src="ams_data.attributes['image-url']"
      :alt="description"
      >
      </b-img>
   </div>
 </div>
</template>

<script>
import {http_v1} from '@/axios'
import {ADMIN_PATH, amsApiResourcePath, apiRoute, COLLECTION_IMAGES} from '@/ams_route'
import {belongsToDescription} from '@/utils'
import DataNavagations from './DataNavagations.vue'

export default {
  components: {
    DataNavagations
  },
  props: {
    id: {
      Type: String
    },
    api_path: {
      Type: String
    }
  },
  data () {
    return {
      ams_type: COLLECTION_IMAGES,
      // ams_api_path: 'api/admin/v1/',
      ams_data: {},
      description: undefined,
      describe_belongs_to_parent: [
        {
          prepend: ' ',
          type: 'interests',
          description_attr: 'name',
          append: ' '
        }],
      describe_belongs_to: [
        {
          prepend: '',
          type: 'collections',
          description_attr: 'name',
          append: ' '
        }
      ],
    }
  },
  computed: {
    isAdminPath() {
      return this.apiPath() == ADMIN_PATH
    }
  },
  methods: {
    apiPath () {
      return this.paramApiPath() || ADMIN_PATH
    },
    paramApiPath() {
      // Note $route and $router are not the same
      return this.api_path || this.$route.query?.api_path
    },
    apiResourcePath() {
      return apiRoute(amsApiResourcePath(this.apiPath(), this.ams_type), this.id)
    },
    doCancel() {
      this.$router.go(-1)
    },
    doUpdate() {
      this.$router.push( {path: '/' + this.ams_type + '/' + this.id + '/update'})
    },
    doHelp() {
      this.$router.push( {path: '/references/CollectionImage/information/' + this.id})
    }
  },
  mounted () {
    http_v1.get(this.apiResourcePath(), {
    }).then(response => {
      if( response.data) {
        this.ams_data = response.data.data
        let item_description = belongsToDescription(
          response.data.data, response.data.included, this.describe_belongs_to
        )
        // Describe the Collection parent Object with relationships to included
        let parent_obj = response.data.included?.find( 
          el =>  
          el.type === "collections" && el.id === response.data.data.attributes['collection-id']
        )
        let parent_description = belongsToDescription(
          parent_obj, response.data.included, this.describe_belongs_to_parent
        )
        this.description = item_description + parent_description
        this.$emit('gotAttrs', this.ams_data?.attributes, this.description)
      }
    }).catch(error => {
      if( error.response && error.response.data) {
          var message = error.response.data.message || JSON.stringify(error.response.data)
          if (error.response.status === 500 ) message = "500 Server Error"
          this.$bvToast.toast(message, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true
          })
        }
      })
  }
}
</script>